
import React from 'react'
import DetailForm from './DetailForm'

import Payment from './Payment'

export default function MainBillingPage() {
  return (
    <div>
        <DetailForm/>
        <Payment/>
    </div>
  )
}
